// extracted by mini-css-extract-plugin
export var close = "Modal-module--close--58476";
export var content = "Modal-module--content--787cb";
export var fluid = "Modal-module--fluid--ed097";
export var lg = "Modal-module--lg--1c81f";
export var md = "Modal-module--md--89001";
export var modal = "Modal-module--modal--86ea5";
export var noPadding = "Modal-module--noPadding--f27d2";
export var overlay = "Modal-module--overlay--1e934";
export var simple = "Modal-module--simple--9cda5";
export var xl = "Modal-module--xl--a2c71";